export const TABLE_STORAGE_KEY = 'pureBiddingTableState';
export const TABLE_STATE_VERSION = 2;

export const COLUMN_IDS = [
  'context.status',
  'uid',
  'context.create_dt',
  'context.end_dt',
  'route.departure.city_name',
  'route.destination.city_name',
  'cargo',
  'veh.type',
  'cost.start',
  'cost.last',
  'winner',
  'meta.service_name',
  'meta.client_name',
  'task',
];

export const COLUMN_LABELS = {
  'context.status': 'Статус',
  'uid': 'UID',
  'context.create_dt': 'Создан',
  'context.end_dt': 'Окончание',
  'route.departure.city_name': 'Откуда',
  'route.destination.city_name': 'Куда',
  'cargo': 'Груз',
  'veh.type': 'ТС',
  'cost.start': 'Старт цена',
  'cost.last': 'Последняя',
  'winner': 'Победитель',
  'meta.service_name': 'Платформа',
  'meta.client_name': 'Клиент',
  'task': 'Задача',
};

function buildKnownSet() {
  return new Set(COLUMN_IDS);
}

export function normalizeTableState(value) {
  const source = value && typeof value === 'object' ? value : {};
  const known = buildKnownSet();
  const order = Array.isArray(source.columnOrder)
    ? [...new Set(source.columnOrder.filter((id) => known.has(id)))]
    : [];
  const missing = COLUMN_IDS.filter((id) => !order.includes(id));
  const visibility = {};
  if (source.columnVisibility && typeof source.columnVisibility === 'object') {
    COLUMN_IDS.forEach((id) => {
      if (typeof source.columnVisibility[id] === 'boolean') visibility[id] = source.columnVisibility[id];
    });
  }
  if (COLUMN_IDS.every((id) => visibility[id] === false)) visibility[COLUMN_IDS[0]] = true;
  const sizing = {};
  if (source.columnSizing && typeof source.columnSizing === 'object') {
    COLUMN_IDS.forEach((id) => {
      const size = Number(source.columnSizing[id]);
      if (Number.isFinite(size) && size >= 18 && size <= 600) sizing[id] = size;
    });
  }
  return {
    columnOrder: [...order, ...missing],
    columnVisibility: visibility,
    columnSizing: sizing,
  };
}

export function defaultTableState() {
  return normalizeTableState({});
}

export function loadTableState(storage) {
  try {
    const parsed = JSON.parse(storage?.getItem(TABLE_STORAGE_KEY) || 'null');
    if (parsed?.version !== TABLE_STATE_VERSION) return normalizeTableState({});
    return normalizeTableState(parsed.value);
  } catch {
    return normalizeTableState({});
  }
}

export function saveTableState(storage, state) {
  try {
    storage?.setItem(TABLE_STORAGE_KEY, JSON.stringify({ version: TABLE_STATE_VERSION, value: state }));
  } catch {
    /* ignore quota / privacy errors */
  }
}
